import script from "./ReservationActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationActions.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationActions.vue?vue&type=style&index=0&id=23ca4e31&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ca4e31"]])

export default __exports__